import React from "react";
import { Progress } from "antd";
import '../FinancialStrength/FinancialStrength.css'
// import 'antd/dist/antd.css';


const financialData = [
  {
    name: "Cash-To-Debt",
    current: 66.89,
    vsIndustry: 80,
    vsHistory: 90,
  },
  {
    name: "Equity-to-Asset",
    current: 0.65,
    vsIndustry: 60,
    vsHistory: 50,
  },
  {
    name: "Debt-to-Equity",
    current: 0.01,
    vsIndustry: 95,
    vsHistory: 92,
  },
  {
    name: "Debt-to-EBITDA",
    current: 0.02,
    vsIndustry: 90,
    vsHistory: 88,
  },
  {
    name: "Interest Coverage",
    current: 106.19,
    vsIndustry: 85,
    vsHistory: 80,
  },
  {
    name: "Piotroski F-Score",
    current: "8/9",
    vsIndustry: 100,
    vsHistory: 95,
  },
  {
    name: "Altman Z-Score",
    current: 9.92,
    vsIndustry: 70,
    vsHistory: 75,
  },
  {
    name: "Beneish M-Score",
    current: -2.53,
    vsIndustry: 40,
    vsHistory: 30,
  },
  {
    name: "WACC vs ROIC",
    current: "7/4",
    vsIndustry: 50,
    vsHistory: 80,
  },
];

const FinancialStrength = () => {
  return (
    <div className="financial-strength-container">
      <div className="header">
        <h1>Financial Strength</h1>
        <div className="score">
        <Progress percent={100} />
        <div>
          <span>10</span>/10
          </div>
        </div>
      </div>
      <table className="financial-table">
        <thead>
          <tr>
            <th>Name</th>
            <th>Current</th>
            <th>Vs Industry</th>
            <th>Vs History</th>
          </tr>
        </thead>
        <tbody>
          {financialData.map((item, index) => (
            <tr key={index}>
              <td>{item.name}</td>
              <td>
                <div className="bar-chart"></div>
                {item.current}
              </td>
              <td>
                <Progress percent={item.vsIndustry} />
              </td>
              <td>
                <Progress percent={item.vsHistory} />
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};


export default FinancialStrength